import React from "react";
import { Figure as FigureBase } from "../Figure";
import { CategoryChart, prefixValue, suffixValue } from "../processors";
import { FigureSolidDashKpiProvider } from "../categoryChartQueryFns";
import { Paragraph } from "../Paragraph";
import { useCategoryContext } from "../Context";
import { getColor } from "../../themes";
import { CategoryTheme } from "../misc";

interface FigureProps extends FigureSolidDashKpiProvider {
    categoryChart: CategoryChart;
}

export const Figure: React.FC<FigureProps> = ({ title, footer, figure, unit, categoryChart }) => {
    const { category } = useCategoryContext();

    if (!category) return null;

    const theme = category.theme as CategoryTheme;

    return (
        <>
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="col-12" />}
            <div>
                {figure != null && (
                    <FigureBase
                        className="w-100"
                        figureStyle={{
                            color: getColor(theme)
                        }}
                        decimals={figure.decimals}
                        header={
                            !figure.header ? null : <Paragraph title={""} status={true} nid={0} text={figure.header} />
                        }
                        footer={
                            !figure.footer ? null : <Paragraph title={""} status={true} nid={0} text={figure.footer} />
                        }
                        value={figure.value}
                        prefix={prefixValue(figure.value, figure?.unit ?? unit)}
                        suffix={suffixValue(figure.value, figure?.unit ?? unit)}
                        unit={figure?.unit ?? unit}
                        categoryChart={categoryChart}
                        unitInSuffix={figure?.unit ?? unit}
                    />
                )}
            </div>
            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="col-12" />}
        </>
    );
};
